import { render, staticRenderFns } from "./BranchEditCard.vue?vue&type=template&id=00f6b5c0&scoped=true"
import script from "./BranchEditCard.vue?vue&type=script&lang=js"
export * from "./BranchEditCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f6b5c0",
  null
  
)

export default component.exports